import { Button, Checkbox, FileInput, Flex, Grid, Group, Select, Textarea, TextInput } from '@mantine/core'
import { IconAt, IconPhone, IconPhoto, IconSignature } from '@tabler/icons-react'
import PhoneInputField from '../../../components/PhoneInputField/PhoneInputField';
import { renderFile } from '../../../utils/renderFile';


export default function ModerationStaffForm({ form, loading }) {


    const handleAddItem = () => {
        form.insertListItem("about.personalItems", { item: "", value: "" });
    };

    const handleRemoveItem = (index) => {
        form.removeListItem("about.personalItems", index);
    };


    return (
        <Grid style={{ width: "100%" }} justify="center" align="center">
            <Grid.Col span={{ base: 12, sm: 6 }}>
                <TextInput
                    disabled={loading}
                    label="Nombre:"
                    {...form.getInputProps("name")}
                    w={'100%'}
                    placeholder="Juan Antonio"

                />
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 6 }}>
                <TextInput
                    disabled={loading}
                    label="Apellido:"
                    {...form.getInputProps("lastname")}
                    w={'100%'}
                    placeholder="Pérez"

                />
            </Grid.Col>

            <Grid.Col span={{ base: 12, md: 6 }}>
                <TextInput
                    disabled={loading}
                    leftSectionPointerEvents="none"
                    leftSection={<IconAt />}
                    {...form.getInputProps("email")}
                    label="Email:"
                    placeholder="ejemplo@gmail.com"
                />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
                < PhoneInputField
                    disabled={loading}
                    leftSection={<IconPhone />}
                    {...form.getInputProps("phone")}
                    placeholder="3446544456"
                />
            </Grid.Col>

            <Grid.Col span={{ base: 12 }}>
                <Group>
                    <FileInput
                        disabled={loading}
                        {...form.getInputProps("profilePicture")}
                        label="Cargar imagen de perfil"
                        placeholder='Cargar imagen'
                        w={{ base: '100%', sm: 'max-content' }}
                        leftSection={< IconPhoto size={30} />}
                        onChange={(file) => {
                            renderFile(file).then((_fileBase64) => {
                                form.setFieldValue("profilePicture", _fileBase64)
                            })
                        }}
                        accept={['image/*']}
                    />

                    <FileInput
                        disabled={loading}
                        {...form.getInputProps("signature")}
                        label="Cargar firma"
                        placeholder='Cargar imagen'
                        w={{ base: '100%', sm: 'max-content' }}
                        leftSection={< IconSignature size={30} />}
                        onChange={(file) => {
                            renderFile(file).then((_fileBase64) => {
                                form.setFieldValue("signature", _fileBase64)
                            })
                        }}
                        accept={['image/*']}
                    />
                </Group>
            </Grid.Col>

            {form.values.about && (
                <>
                    <Grid.Col span={12}>
                        <Textarea
                            {...form.getInputProps("about.description")}
                            label="Descripción profesional"
                            description="Se mostrará en la página personal y en el apartado de EQUIPO en una capacitación"
                        />
                    </Grid.Col>

                    <Grid.Col span={12}>
                        <Flex justify="space-between" align="center" mb="sm">
                            <h4 style={{ fontSize: 'var(--fs-body)' }}>Información personal</h4>
                            <Button size="xs" variant="light" onClick={handleAddItem}>
                                + Agregar ítem
                            </Button>
                        </Flex>
                        {form.values.about?.personalItems?.length === 0 && <p style={{ fontSize: "var(--fs-body)" }}>Haz click en el botón agregar item para escribir</p>}
                        {form.values.about.personalItems?.map((personalItem, index) => (
                            <Flex key={index} gap="sm" align="end" mb={8}>
                                <Select
                                    description='Nombres con lo que se agrupará en la pagina dedicada. Si selecciona otro no se mostrará ese título, solo el contenido.'
                                    data={['Formación', 'Experiencia', 'Otro']}
                                    label="Etiqueta"
                                    style={{ flex: 1 }}
                                    {...form.getInputProps(`about.personalItems.${index}.item`)}
                                />
                                <TextInput
                                    placeholder="Valor (ej: Veterinario clínico)"
                                    label="Contenido"
                                    style={{ flex: 1 }}
                                    {...form.getInputProps(`about.personalItems.${index}.value`)}
                                />
                                <Button
                                    color="red"
                                    variant='outline'
                                    onClick={() => handleRemoveItem(index)}
                                >
                                    Eliminar
                                </Button>
                            </Flex>
                        ))}
                    </Grid.Col>
                </>
            )}

            <Grid.Col span={12}>
                <Button
                    type="submit"
                    className="eventCalendarForm__form__button"
                    disabled={loading}
                >
                    Guardar profesor/a
                </Button>
            </Grid.Col>
        </Grid>
    )
}
